type TAnalyticType = 'FirebaseInitialized';

export const recordAnalytic = (type: TAnalyticType, data: Record<string, string | number>): void => {
  if (window.newrelic) {
    window.newrelic.addPageAction(type, data);
  }
}